import { withQueryParams } from '@web/common/url'

const ONELINK_BASE = 'https://anyclass.onelink.me/lj9w/0z7a6uck'

/** Строит OneLink; при непустом токене прокидывает бесшовную авторизацию. */
export function buildOneLink (token: string): string {
  return withQueryParams(ONELINK_BASE, {
    c: 'post_first_day',
    deep_link_value: token ? 'token' : null,
    deep_link_sub1: token || null
  })
}
